import React from 'react';
import File from '../../../../../components/File';
import { ExpandHeader, ExpandWrapper } from '../ExpandableTable/style';
import { FilesContainer, ModalWrapper, SearchFilesList, TabItem, TabsContainer } from './style';
import Slider from 'react-slick';
import NextIcon from '../../../../../assets/icons/slide-right.svg?react';
import PrevIcon from '../../../../../assets/icons/slide-left.svg?react';
import FilterIcon from '../../../../../assets/icons/filter.svg?react';
import { useState } from 'react';
import Modal from '../../../../../components/Modal';
import sidebarStore from '../../../../../store/sidebar';
import SearchInput from '../../../../../components/SearchInput';
import Tooltip from '../../../../../components/Tooltip';

const SlideNext = props => {
  const { className, onClick, style } = props;
  return <NextIcon className={className} onClick={onClick} style={style} />;
};

const SlidePrev = props => {
  const { className, onClick, style } = props;
  return <PrevIcon className={className} onClick={onClick} style={style} />;
};

const settings = {
  dots: false,
  infinite: false,
  speed: 100,
  slidesToShow: 7,
  slidesToScroll: 1,
  nextArrow: <SlideNext />,
  prevArrow: <SlidePrev />
};

const tabs = [
  'Balance sheet',
  'Cash and Foreign Currency',
  'Price list',
  'RTX Working price',
  'Price list and others',
  'Others'
];

const UploadedFiles = ({ files, onSelectFile, selectedFile, showTabs, onDelete }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [openFilesModal, setOpenFilesModal] = useState(false);

  const toggle = () => setOpenFilesModal(prev => !prev);
  return (
    <ExpandWrapper>
      <ExpandHeader>
        <h4>
          Uploaded files{' '}
          {files && files.length > 0 ? (
            <>
              ({files?.length} {files.length === 1 ? 'file' : 'files'}){' '}
            </>
          ) : (
            ''
          )}
        </h4>
      </ExpandHeader>

      <FilesContainer>
        <Tooltip id="file-name" />
        {files.length > 6 ? (
          <Slider {...settings}>
            {files.map((file, f) => (
              <div key={f} onClick={() => onSelectFile(file)}>
                <File
                  type={file.type}
                  title={file.name}
                  size={file.size}
                  isActive={selectedFile?.id === file.id}
                  onDelete={() => onDelete(file)}
                />
              </div>
            ))}
          </Slider>
        ) : (
          <div className="box">
            {files.map((file, f) => (
              <div key={f} onClick={() => onSelectFile(file)}>
                <File
                  type={file.type}
                  title={file.name}
                  size={file.size}
                  isActive={selectedFile?.id === file.id}
                  onDelete={() => onDelete(file)}
                />
              </div>
            ))}
          </div>
        )}
      </FilesContainer>

      {showTabs && (
        <TabsContainer>
          <div className="tabs">
            <Slider {...settings} slidesToShow={4}>
              {tabs.map((tab, t) => (
                <div key={t} onClick={() => setSelectedTab(t)}>
                  <TabItem active={t === selectedTab}>{tab}</TabItem>
                </div>
              ))}
            </Slider>
          </div>
          <button>
            <FilterIcon />
          </button>
          <div className="file-count">
            <p>1</p> &nbsp;/&nbsp; <p>6</p>
          </div>
        </TabsContainer>
      )}

      <Modal
        title="Files"
        open={openFilesModal}
        toggle={toggle}
        isOpenSidebar={sidebarStore.isOpen}
      >
        <ModalWrapper>
          <SearchInput htmlFor="SearchFiles" />

          <SearchFilesList>
            {/* {files.map((file, f) => {
              const Icon = fileIcons[file.type]
              return (
                <li key={f} onClick={() => onSelectFile(file)}>
                  <Icon /> {file.title}
                </li>
              )
            })} */}
          </SearchFilesList>
        </ModalWrapper>
      </Modal>
    </ExpandWrapper>
  );
};

export default UploadedFiles;
